// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatElevationHeader, FormatOverall, FormatOverallHeader } from './Formatters'

const columns = [
  {
    columnKey: 'asr',
    columnHeader: 'ASR Number',
    sortable: true,
  }, {
    columnKey: 'latitude',
    columnHeader: 'Latitude',
  }, {
    columnKey: 'longitude',
    columnHeader: 'Longitude',
  }, {
    columnKey: 'elevation',
    columnHeader: 'Ground Elev',
    headerFormatter: FormatElevationHeader,
    sortable: true,
  }, {
    cellFormatter: FormatOverall,
    columnKey: 'overallHeight',
    columnHeader: 'Overall Height',
    headerFormatter: FormatOverallHeader,
    sortable: true,
  }, {
    columnKey: 'entityName',
    columnHeader: 'Tower Owner',
    columnWidth: '260px',
    sortable: true,
  }, {
    columnKey: 'statusCode',
    columnHeader: 'Status',
    columnWidth: '55px',
    sortable: true,
  },
]

export default columns
